import {defaultCurrency, defaultPartner, defaultSorting} from '../../../config/app-config';
import {
  FETCH_SRP_DATA,
  ISrpStoreState,
  RESET_FILTER,
  SrpActionTypes,
  TOGGLE_LOADING,
  UPDATE_FILTER,
  UPDATE_SRP_CONFIG,
  RESET_SRP_DATA,
  UPDATE_SRP_OFFER_DATA,
} from './types';

const initialState: ISrpStoreState = {
  hasData: null,
  isLoading: false,
  partner: defaultPartner,
  srpConfig: {
    s: defaultSorting,
    cur: defaultCurrency,
    im: true,
    filter: {},
  },
  srpData: {
    city_meta_info: null,
    data: [],
    next: '',
    error: false,
  },
  srpOfferData: null,
};

export default function srpPageReducer(state = initialState, action: SrpActionTypes) {
  switch (action.type) {
    case UPDATE_SRP_CONFIG:
      return {
        ...state,
        srpConfig: {
          ...state.srpConfig,
          ...action.actionData,
        },
      };

    case FETCH_SRP_DATA:
      const {srpData} = state;
      const {data: currentData} = srpData;
      if (action.loadingMore) {
        return {
          ...state,
          srpData: {
            ...state.srpData,
            data: [...currentData, ...action?.actionData?.data],
            next: action?.actionData?.next,
            error: action?.actionData?.error || false,
          },
          hasData: action?.actionData?.data?.length > 0,
        };
      }

      return {
        ...state,
        srpData: {
          city_meta_info: action?.actionData?.city_meta_info,
          data: action?.actionData?.data,
          next: action?.actionData?.next,
          error: action?.actionData?.error || false,
        },
        hasData: action?.actionData?.data?.length > 0,
      };

    case UPDATE_FILTER:
      return {
        ...state,
        srpConfig: {
          ...state.srpConfig,
          filter: {
            ...state.srpConfig.filter,
            ...action.actionData,
          },
        },
      };

    case RESET_FILTER:
      return {
        ...state,
        srpConfig: {
          ...state.srpConfig,
          filter: {},
        },
      };

    case UPDATE_SRP_OFFER_DATA:
      return {
        ...state,
        srpOfferData: {
          ...state.srpOfferData,
          ...action.actionData,
        },
      };

    case TOGGLE_LOADING:
      return {
        ...state,
        isLoading: action.actionData,
      };

    case RESET_SRP_DATA:
      return {
        ...state,
        ...initialState,
      };

    default:
      return state;
  }
}
